import { ref } from "vue";

export const jwt = ref('')